export default "__VITE_ASSET__CqKkNe2j__"